// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBarB_form__f7F45","search":"SearchBarB_search__3lgz8","go":"SearchBarB_go__1MBkV"};